import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import Navbar from './components/Navbar';
import Main from './components/Main';
import Footer from './components/Footer';
import Clinic from './components/Clinic';
import NewPatient from './components/NewPatient';
import Patient from './components/Patient';
import { useState, useEffect } from 'react';
import Login from './common/Login';
import NewClinic from './components/NewClinic';
import useAuth, { useAuthContext } from './hooks/useAuth';

function App() {
  const [ptNumber, setPtNumber] = useState();
  const location = useLocation();
  const history = useHistory();
  const { getCurrentUser, logout } = useAuth();
  const { token, setToken, user, setUser } = useAuthContext();
  const [flashMessage, setFlashMessage] = useState('');
  const [flashMessageSuccess, setFlashMessageSuccess] = useState(true);

  useEffect(() => {
    async function checkSession() {
      if (!user) {
        try {
          const userObject = await getCurrentUser();
          if (userObject) {
            setUser(userObject);
            setToken(userObject?.signInUserSession?.idToken?.jwtToken);
          }
        } catch (e) {
          console.log('error getting user: ', e);
          console.log(history, location);
        }
      }
    }
    if (!ptNumber && user) {
      history.push('/');
    } else {
      history.push(`/patient/${ptNumber}`);
    }

    checkSession();
  }, [user, token, ptNumber]);

  // called after successful session-level logout on server
  // sets back to default values passed to useState above.
  const invalidateState = () => {
    setToken(null);
    setPtNumber('');
    setUser(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      invalidateState();
      if (location.pathname !== '/') {
        history.replace('/login');
      }
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };

  const patientSearch = (patient) => {
    setPtNumber(patient);
    console.log(
      'setting patient number with pt: ',
      patient,
      '=>',
      getPtNumber()
    );
  };

  const getPtNumber = () => {
    console.log('getPtNumber:', ptNumber);

    return ptNumber;
  };

  const newPatientCallback = (success = true) => {
    setFlashMessage(
      success
        ? 'Patient successfully added!'
        : 'An error occurred: patient was not added.'
    );
    setFlashMessageSuccess(success);
  };

  const userObject = useAuthContext();
  const is_admin = userObject?.user?.username === 'admin';
  return (
    <div className="App">
      <Navbar logout={handleLogout} search={patientSearch} />
      <Switch>
        {is_admin && (
          <Route path="/clinic">
            <Clinic />
          </Route>
        )}
        {is_admin && (
          <Route path="/newclinic">
            <NewClinic />
          </Route>
        )}
        {ptNumber && (
          <Route path="/patient">
            <Patient ptNumber={getPtNumber()} />
          </Route>
        )}
        <Route path="/newpatient">
          <NewPatient newPatientCallback={newPatientCallback} />
        </Route>
        <Route path="/login">{token ? <Redirect to="/" /> : <Login />}</Route>
        <Route path="/">
          <Main />
        </Route>
      </Switch>
      <Footer msg={flashMessage} success={flashMessageSuccess} />
    </div>
  );
}

export default App;
